import * as React from 'react';
import { DOB, LAST_NAME, POSTCODE, USERNAME } from 'ts/constants/UrlParams';
import { findAccountForManualReg } from 'ts/services/find-account/FindAccountService';
import { AccountNumberPage } from '../../pages/account-number/AccountNumberPage';
import { Content } from '../../pages/account-number/Interfaces';
import { sendOtcAndRedirect } from './Actions';
import { navigateToErrorPage } from '../../pages/error/ErrorNavigation';
import { ERROR_CODES } from '../../pages/error/ErrorCodes';
import { ErrorFlow } from '../../pages/error/ErrorFlow';

interface ManualRegAccountNumberPageProps {
  history: History;
  location: Location;
}

const content: Content = {
  analytics: {
    navigation: {
      friendlyUri: 'originenergy:my-account:auth:manual-reg-verify-account',
    },
    errorForm: {
      formName: 'auth:manual-reg',
      errorMessage: 'auth:manual-reg:invalid-account-number',
      errorCode: 'invalid-account-number',
    },
    interaction: {
      click: {
        appName: 'auth:manual-reg',
      },
    },
  },
  copy: {
    headingText: 'We need to match you up',
    infoText: 'Please enter your account number from your bill or contract pack',
    alertBoxText:
      "Hmm, we can't find an account linked to those details. Please check and try again, or [contact us](mailto:support@originenergy.com.au).",
  },
};

const nextAction = (history: History) => async (username: string) => {
  sendOtcAndRedirect(history, username);
};

const errorPageAction = (history: History) => (statusCode: number) => {
  const errorCode =
    statusCode === 422
      ? ERROR_CODES.MANUAL_REG_SAP_EMAIL_ERROR
      : ERROR_CODES.MANUAL_REG_ACCOUNT_SEARCH;
  navigateToErrorPage(errorCode, ErrorFlow.manualReg, '', history, true);
};

const findAccountAction = (
  lastName: string,
  dob: string,
  postcode: string,
  accountNumber: string,
  userProvidedEmail: string,
) => {
  return findAccountForManualReg(lastName, dob, postcode, accountNumber, userProvidedEmail);
};

const ManualRegAccountNumberPage: React.FC<ManualRegAccountNumberPageProps> = ({
  history,
  location,
}) => {
  const searchParams = new URLSearchParams(location.search);
  return (
    <AccountNumberPage
      userProvidedEmail={searchParams.get(USERNAME)}
      findAccountAction={findAccountAction}
      lastName={searchParams.get(LAST_NAME)}
      dob={searchParams.get(DOB)}
      postcode={searchParams.get(POSTCODE)}
      errorPageAction={errorPageAction(history)}
      content={content}
      history={history}
      nextAction={nextAction(history)}
    />
  );
};

export { ManualRegAccountNumberPage };
